.icon-container {
    color: var(--grey-dk);
    transform: rotate(-90deg);
    transition: transform 0.1s ease-in-out;
}

.icon-container--rotate {
    transform: rotate(0deg);
}

.add-button-container {
    position: absolute;
    right: 12px;
    top: 12px;
    flex-shrink: 0;
    height: 15px;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 8px;
}
